import React, { useState } from "react";
import { Box, Grid } from "@mui/material";
import { Button, TextField } from "@platform/design-system";

import useMfa from "../auth/useMfa";
import { extractErrorMessage } from "../utils";
import { submitEvent } from "../utils/tracking";

const MfaChallenge = (props = false) => {
  const [code, setCode] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const { validateMfa, mfaState, sendMfaCode } = useMfa();

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await validateMfa(code, mfaState.userId);
    } catch (e) {
      const errorMessage = extractErrorMessage(e, "Invalid code");
      submitEvent("Invalid MFA Code Seen");
      submitEvent("Error Viewed", {
        error_type: "invalid_mfa_code",
        error_reason: errorMessage,
      });
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleResendCode = async () => {
    setLoading(true);
    setError(null);
    try {
      await sendMfaCode(mfaState.userId);
    } catch (e) {
      const errorMessage = extractErrorMessage(e, "Invalid code");
      submitEvent("Error Viewed", {
        error_type: "resent_mfa_code",
        error_reason: errorMessage,
      });
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Grid container flexDirection="column" spacing={2}>
        <Grid size={12} maxWidth>
          Enter the verification code we just sent you on your registered email
          account.
          <TextField
            margin="dense"
            value={code}
            error={!!error}
            helperText={error}
            onChange={(e) => setCode(e.target.value)}
            onFocus={() => setError(null)}
            fullWidth
            id="code"
            name="code"
            type="text"
            autoComplete="off"
          />
        </Grid>
      </Grid>
      <Grid
        container
        flexDirection="row"
        mt={1}
        spacing={2}
        justifyContent="center"
      >
        <Grid size={12}>
          <Button
            fullWidth
            variant="primary"
            size="lg"
            onClick={handleSubmit}
            loading={loading}
          >
            {props.disable ? "Disable" : "Verify"}
          </Button>
        </Grid>
        <Grid size={12}>
          If you didn’t receive the code,{" "}
          <Button variant="tertiary" onClick={handleResendCode}>
            resend.
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default MfaChallenge;
